import React from "react";
import { useLocation } from "react-router-dom";
import { getBlogById } from "../../data/blogService";

function BlogDetails() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const id = searchParams.get("id");

  const blog = getBlogById(id);

  if (!blog) {
    return (
      <main>
        <div className="container pt-14 pb-9">
          <h2>Blog post not found</h2>
          <p>The requested blog post could not be found.</p>
          <a href="/blogs" className="btn btn-primary">Back to Insights</a>
        </div>
      </main>
    );
  }

  const formatDate = (dateStr) => {
    return new Date(dateStr).toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  return (
    <>
      <div className="spinner-loader bg-primary text-white">
        <div className="spinner-border" role="status"></div>
      </div>

      <main>
        <section id="article-header" className="position-relative">
          <div className="container pt-14 pb-9 pb-lg-11 position-relative">
            <article className="row pt-lg-7 pb-11">
              <div className="col-lg-10 col-xl-8">
                <div className="position-relative pb-3 pb-lg-0">
                  <div className="d-flex align-items-center w-100">
                    {blog.source && (
                      <a href="#!" className="badge bg-primary rounded-pill me-3">
                        {blog.source}
                      </a>
                    )}
                    <small className="text-body-secondary">
                      {formatDate(blog.date)}
                    </small>
                  </div>

                  <div>
                    <h2 className="my-4 display-4">{blog.title}</h2>
                    <div className="d-flex pt-2 mb-0 small align-items-center">
                      <img
                        src="assets/img/avatar/3.jpg"
                        alt=""
                        className="width-3x height-3x rounded-circle me-2"
                      />
                      <span className="text-body-secondary d-inline-block">
                        By{" "}
                        <span className="text-dark">{blog.author}</span>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </article>
          </div>

          <svg
            className="position-absolute start-0 bottom-0"
            preserveAspectRatio="none"
            width="100%"
            height="120"
            viewBox="0 0 800 240"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M800 240H0L800 0V240Z" fill="currentColor" />
          </svg>
        </section>

        <section className="position-relative border-bottom">
          <div className="container pb-9 pb-lg-11">
            {blog.image && (
              <img
                src={`assets/img/960x900/${blog.image}`}
                alt={blog.title}
                className="img-fluid shadow-lg rounded-4 mb-7 mb-lg-9 position-relative mt-n14"
              />
            )}

            <div className="row">
              <div className="col-xl-9 mx-auto">
                <article className="article mb-9">
                  <p className="lead mb-4 dropcap">{blog.excerpt}</p>

                  {blog.link && (
                    <div className="mt-5">
                      <a
                        href={blog.link}
                        target="_blank"
                        rel="noreferrer"
                        className="btn btn-primary btn-lg"
                      >
                        Read Full Article <i className="bx bx-link-external ms-2"></i>
                      </a>
                    </div>
                  )}
                </article>

                <div className="d-flex justify-content-between align-items-center mb-9">
                  <a href="/blogs" className="btn btn-outline-primary">
                    <i className="bx bx-arrow-back me-2"></i> Back to Insights
                  </a>
                  <div className="d-flex align-items-center">
                    <div className="me-3 small text-body-secondary">
                      Share Article
                    </div>
                    <div>
                      <a href="#!" className="d-inline-block me-1">
                        <img
                          src="assets/img/brands/facebook.svg"
                          alt=""
                          className="width-2x height-2x hover-lift"
                        />
                      </a>
                      <a href="#!" className="d-inline-block me-1">
                        <img
                          src="assets/img/brands/twitter.svg"
                          alt=""
                          className="width-2x height-2x hover-lift"
                        />
                      </a>
                      <a href="#!" className="d-inline-block me-1">
                        <img
                          src="assets/img/brands/Linkedin.svg"
                          alt=""
                          className="width-2x height-2x hover-lift"
                        />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}

export default BlogDetails;
